import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LoaderService } from '../../../services/loader/loader.service';
import { HttpService } from '../../../services/http/http.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { BookAppointmentPopupComponent } from '../book-appointment-popup/book-appointment-popup.component';
import { ConfirmPopupComponent } from '../../../shared/popups/confirm-popup/confirm-popup.component';
/**
 * This component is used to show the list of booked appointments
 */
@Component({
  selector: 'app-appointment',
  templateUrl: './appointment-list.component.html',
  styleUrls: ['./appointment-list.component.scss']
})

export class AppointmentListComponent implements OnInit {
  displayedColumns: string[] = ['name', 'startDate', 'time', 'status', 'action'];
  dataSource = [];
  isAPICalled = false;
  @Input() patientId: any = null;
  @Input() patientDetails: any = {};
  @Output() public count = new EventEmitter();

  constructor(
    private httpService: HttpService,
    private loader: LoaderService,
    private toastr: ToastrService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    // this.getBookingData();
  }

  booking() {
    const dialogRef = this.dialog.open(BookAppointmentPopupComponent, {
      width: '900px',
      data: { 
        type: "newBooking", 
        patientId: this.patientId,
        patientDetails: this.patientDetails,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event) {
        this.getBookingData();
      }
    });
  }

  getBookingData() {
    this.loader.show('progress');
    this.httpService.get(`bookings/users/${this.patientId}`)
      .subscribe((response: any) => {
        if(response && response.data){
          this.dataSource = this.formatData(response.data).sort(function(d1, d2) {
            const date1 = new Date(d1.startDate);
            const date2 = new Date(d2.startDate);
            if (date1 > date2) return 1;
            if (date1 < date2) return -1;
          })
          this.count.emit(this.dataSource.length);
        }
        this.isAPICalled = true;
        this.loader.hide('progress');
      }, error => {
        this.toastr.warning(error, 'Appointment', {
          progressBar: true, timeOut: 3000
        });
      })
  }

  formatData(data){
    data.map(item =>{
      if(item.status === 'UNAVAILABLE'){
        item.bookingStatus = 'Booked';
      }else if(item.status === 'CANCELLED'){
        item.bookingStatus = 'Cancelled';
      }
    })
    return data;
  }

  cancelBooking(bookingId) {
    this.loader.show('progress');
    const data = {}
    this.httpService.put(`bookings/CANCELLED?bookingId=${bookingId}`, data)
      .subscribe((response: any) => {
        this.dataSource = response.data;
        this.getBookingData();
        this.loader.hide('progress');
      }, error => {
        this.toastr.warning(error, 'Appointment', {
          progressBar: true, timeOut: 3000
        });
      })
  }

  cancelConfirmation(bookingId): void {
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      width: '450px',
      data: {
        title: { text: 'Confirmation' },
        subTitle: { text: `Are you sure you want to cancel appointment?` },
        cancelBtn: { text: 'No' },
        okBtn: { text: 'Yes' }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event) {
        this.cancelBooking(bookingId)
      }
    });
  }

  rescheduleBooking(bookingData) {
    const dialogRef = this.dialog.open(BookAppointmentPopupComponent, {
      width: '900px',
      data: { 
        type: "rescheduleBooking", 
        patientId: this.patientId,
        patientDetails: this.patientDetails,
        bookingData: bookingData ,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event) {
        this.getBookingData();
      }
    });
  }
}
